import React from 'react'
import ProductTextSection from 'app/React/InspirationUniverse/ProductTextSection'
import ProductImageSection from 'app/React/InspirationUniverse/ProductImageSection'
import ProductImageSlider from 'app/React/InspirationUniverse/ProductImageSlider'
import classNames from 'classnames'

export default function Product ({ index, product }) {

  const imageOne = product?.image1 ?? null
  const imageTwo = product?.image2 ?? null

  return (
    <section
      className={classNames("mtt-iu-product", {
        "mtt-iu-product--grey-bg": index % 2 === 1
      })}
      data-product-id={product?.id ?? ''}
    >
      <div className="mtt-iu-product__inner page_container">

        <div className="mtt-iu-product__content-container">
          <ProductTextSection
            tagline={product?.tagline ?? ''}
            title={product?.title ?? ''}
            description={product?.description ?? ''}
            fromPrice={product?.fromPrice ?? ''}
            permalink={product?.permalink ?? ''}
            buttonText={product?.buttonText ?? ''}
          />
          <ProductImageSection imageObj={imageOne}/>
          <ProductImageSection imageObj={imageTwo}/>
        </div>

        <ProductImageSlider
          gallery={product?.gallery ?? []}
          imageOne={imageOne}
          imageTwo={imageTwo}
        />

      </div>
    </section>
  )
}
